import React from "react";
import { connect } from "react-redux";
import FormElement from "components/FormElement";
import { setValue } from "actions/request";
import { requestFields, toggleOptions } from "helpers/ManufSiteHelper";

class SiteOptions extends React.Component {
  requestField = requestFields.siteOption;

  // componentWillUnmount() {
  //   this.props.setValue(this.requestField, "");
  // }

  render() {
    const { request } = this.props;

    return (
      <FormElement
        type="toggleRadioGroup"
        id={this.requestField}
        label="Manufacturing Site"
        value={request[this.requestField]}
        list={toggleOptions}
      />
    );
  }
}

function mapStateToProps({ request }) {
  return { request };
}

export default connect(mapStateToProps, { setValue })(SiteOptions);
